<template>
  <div v-if="isMounted" class="flex flex-col">
    <BaseSection heading="Test SRT erfassen">
      <RecordDeviceDetails v-model:device="device" :validation="v$.device" />
    </BaseSection>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps, inject, ref, Ref } from 'vue';
import AdditionalInfo from '@/components/Forms/DeviceFormComponents/AdditionalInfo.vue';
import RecordDeviceDetails from '@/components/Forms/DeviceFormComponents/RecordDeviceDetails.vue';
import { useValidation } from '@/composables/useValidation';
import { SmartRadiatorThermostat } from '@/models/devices/Device';
import { useOrderStore } from '@/store/order/orderStore';
import { ImageCaptureRef } from '@/components/Forms/DeviceFormComponents/ImageCapture.vue';
import BaseSection from '@/components/UI/Card/BaseSection.vue';
import { InspectionPoint } from '@/models/inspectionPoint/InspectionPoint';
import BaseTextarea from '@/components/UI/Note/BaseTextarea.vue';

const props = defineProps<{
  device: SmartRadiatorThermostat;
  installationPoint: InspectionPoint;
}>();

const isMounted = inject('isMounted') as Ref<boolean>;
const imageCaptureRef: Ref<ImageCaptureRef | null> = ref(null);

const emit = defineEmits(['update-entity']);

const device = computed(() => {
  return props.device;
});

const installationPoint = computed(() => {
  return props.installationPoint;
});

const isOnSiteInspection = computed(() => {
  return useOrderStore().isOnSiteInspection();
});

const { v$, isFormValid } = useValidation(
  { device },
  { isOnSiteInspection: isOnSiteInspection.value }
);

defineExpose({
  isFormValid: computed(() => isFormValid.value),
  saveImage: () => imageCaptureRef.value?.saveImage(),
});
</script>
